import React from 'react';

import { useLocation, Navigate } from 'react-router-dom';
import moment from 'moment';
import { useQuery, useQueryClient } from '@tanstack/react-query';

import { hasAuthData } from '../../helpers/authStorage';
import { useServicerStore, useUiStore } from '../../store';
import TermsOfServiceService from '../../services/TermsOfServiceService';

export default function PrivateRoute({ children, role }) {
  const location = useLocation();

  const queryClient = useQueryClient();

  const { data: termsOfService } = useQuery({
    queryKey: ['terms_of_service'],
    queryFn: TermsOfServiceService.getTermsOfService,
  });

  const lenders = queryClient
    .getQueriesData({
      queryKey: ['lenderFromHook'],
    })
    ?.map((query) => query[1]);

  const userRole = useServicerStore((state) => state.userRole);
  const setOnLoginRedirectUrl = useUiStore(
    (state) => state.setOnLoginRedirectUrl
  );

  const isAuthenticated = hasAuthData();

  if (!isAuthenticated) {
    setOnLoginRedirectUrl(window.location.pathname + window.location.search);
    return <Navigate to="/login" />;
  }

  // If user is a lender and not onboarded or needs to accept TOS, redirect to onboarding page
  const needsOnboarindg = lenders?.some((lender) => {
    return !lender?.onboarded;
  });
  const needsTos = lenders?.some((lender) => {
    return (
      !lender?.accepted_tos_date ||
      !moment(lender?.accepted_tos_date).isSameOrAfter(
        moment(termsOfService?.updated_date)
      )
    );
  });

  if (
    userRole === 'lender' &&
    lenders?.length &&
    termsOfService &&
    location.pathname !== '/lender_onboarding'
  ) {
    if (needsOnboarindg) {
      return <Navigate to="/lender_onboarding" />;
    }

    if (needsTos) {
      return <Navigate to="/lender_onboarding?terms=true" />;
    }
  }

  if (!role) {
    return children;
  }

  const allowedRoles = Array.isArray(role) ? role : [role];

  const isAllowed = allowedRoles.includes(userRole);

  if (!isAllowed) {
    setOnLoginRedirectUrl(window.location.pathname + window.location.search);
    return <Navigate to="/login" />;
  }

  return children;
}
